import {z} from 'zod';

export const loginPerspectiveSchema = z.enum(['member', 'staff']);
/** Defines the UX of the login form and adjacent UIs. For example: login attempts from my-dot will declare the 'staff' perspective */
export type LoginPerspective = z.infer<typeof loginPerspectiveSchema>;

export const parseLoginPerspective = (
  value: unknown,
): LoginPerspective | undefined => {
  const parsed = loginPerspectiveSchema.safeParse(value);
  return parsed?.data;
};
